import { nanoid } from 'nanoid';
export default nanoid;
flarum.reg.add('core', 'common/utils/generateElementId', nanoid);